import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';
import store from '@/store';
import redirectUtil from '@/shared/utils/redirect.util';
import { instanciaAxios } from './base.service';

const recuperacao = 'recuperacao';

export default class RecuperacaoService {
  async enviarCodigo(cpf: string, vue: Vue): Promise<any> {
    await instanciaAxios.get(`${recuperacao}/administrativo/${cpf}`)
      .then((response: any) => {
        redirectUtil.redirecionar(vue, 'alterarSenha', { cpf, email: response.data });
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, `Enviamos o código de confirmação para ${response.data}`);
      })
      .catch((error: any) => {
        console.error(error);
        // redirectUtil.redirecionar(vue, 'alterarSenha', { cpf: cpf, email: 'edsonnoboru@gmail.com' });
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
      });
  }
}
